import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "cruiseWithConfidenceCard",
  type: "object",
  title: "Cruise with confidence Card",
  fields: [
    {
      name: "title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "description",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required()
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  }
});
